import { render, staticRenderFns } from "./ManagementGuide.vue?vue&type=template&id=470227ba&scoped=true&"
import script from "./ManagementGuide.vue?vue&type=script&lang=js&"
export * from "./ManagementGuide.vue?vue&type=script&lang=js&"
import style0 from "./ManagementGuide.vue?vue&type=style&index=0&id=470227ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470227ba",
  null
  
)

export default component.exports